import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { CategoryRestrictionProfilePresetConfigurationEffects } from './category-restriction-profile-preset-configuration.effects';
import { categoryRestrictionProfilePresetConfigurationReducer } from './category-restriction-profile-preset-configuration.reducer';

export const provideCategoryRestrictionProfilePresetConfigurationStore = () => [
  provideState('categoryRestrictionProfilePresetConfiguration', categoryRestrictionProfilePresetConfigurationReducer),
  provideEffects([CategoryRestrictionProfilePresetConfigurationEffects]),
];
